import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'monthDayYear'
})
export class MonthDayYearPipe implements PipeTransform {
  pad(n): number {
    return parseInt(n < 10 ? '0' + n : n, 10);
  }

  transform(value: string): string {
    if (null === value) {
      return;
    }

    const lastChar = value.slice(-1);
    if (lastChar !== 'Z') {
      value = value + 'Z';
    }
    
    const d = new Date(value);

    return (
      this.pad(d.getUTCMonth() + 1) + '/' + this.pad(d.getUTCDate()) + '/' + d.getUTCFullYear()
    );
  }
}
